import React from 'react';
import { Link } from 'react-router-dom';
import { AppSettings } from '../../config/app-settings.js';
import axios from 'axios';
import Preloader from "../../components/custom/preLoader";
import { withRouter } from 'react-router-dom';
import showErrorToast, { showSuccessToast } from "../../components/toast/toast";
import { CheckUserExpiry, setAuthTokens } from "../../components/content/axiosConfig.js";
import { COUNTRY_OPTIONS } from "../../utils/countries";

class Register extends React.Component {
  static contextType = AppSettings;

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      redirect: false,
      loading: false,
      registerAs: "organization",
    };
  }

  componentDidMount() {
    this.context.handleSetAppSidebarNone(true);
    this.context.handleSetAppHeaderNone(true);
    this.context.handleSetAppContentClass('p-0');
  }

  async handleSubmit(event) {
    this.setState({ loading: true });
    event.preventDefault();
    const { registerAs } = this.state;
    const firstName = event.target.txtFirstName.value;
    const lastName = event.target.txtLastName.value;
    const emailAddress = event.target.txtEmailAddress.value.trim();
    const password = event.target.txtPassword.value.trim();
    const agreement = event.target.agreementCheckbox.checked;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (firstName.length > 0 && lastName.length > 0) {
      if (emailAddress.length > 0 && emailRegex.test(emailAddress)) {
        if (password.length >= 8) {
          if (agreement === true) {
            try {
              let API_URL = "";
              if (process.env.REACT_APP_Environment === 'development')
                API_URL = process.env.REACT_APP_API_URL;
              else
                API_URL = process.env.REACT_APP_API_URL_Production;

              if (registerAs === "scientist") {
                await axios.post(API_URL + "api/User/RegisterScientist", {
                  FullName: firstName + " " + lastName,
                  Email: emailAddress,
                  Password: password,
                });
              } else if (registerAs === "company") {
                const companyName = (
                  event.target.txtCompanyName?.value || `${firstName} ${lastName}`
                ).trim();
                const companyRes = await axios.post(API_URL + "api/company/Register", {
                  CompanyName: companyName,
                  FullName: firstName + " " + lastName,
                  Email: emailAddress,
                  Password: password,
                  Phone: (event.target.txtCompanyPhone?.value || "").trim(),
                  Address: (event.target.txtCompanyAddress?.value || "").trim(),
                  City: (event.target.txtCompanyCity?.value || "").trim(),
                  State: (event.target.txtCompanyState?.value || "").trim() || undefined,
                  PostalCode: (event.target.txtCompanyPostal?.value || "").trim() || undefined,
                  EIN: (event.target.txtCompanyEin?.value || "").trim() || undefined,
                  Country: (event.target.txtCompanyCountry?.value || "US").trim(),
                });
                const { token, refreshToken, User } = companyRes.data;
                setAuthTokens(token, refreshToken, User);
                await CheckUserExpiry();
                showSuccessToast("Pond Management Company created. Welcome!");
                this.props.history.push("/company/accounts");
                this.setState({ loading: false });
                return;
              } else {
                await axios.post(API_URL + "api/fisher/Register", {
                  FullName: firstName + " " + lastName,
                  Email: emailAddress,
                  Password: password,
                  Status: false
                });
              }

              const loginResponse = await axios.post(API_URL + "api/User/Login", {
                Email: emailAddress,
                Password: password,
              });
              const { token, refreshToken, User } = loginResponse.data;
              setAuthTokens(token, refreshToken, User);
              await CheckUserExpiry();

              showSuccessToast(
                registerAs === "scientist"
                  ? "Scientist account created. Welcome!"
                  : "Account created. Welcome!"
              );
              this.props.history.push("/");
              this.setState({ loading: false });
                } catch (error) {
      this.setState({ loading: false });
      const status = error.response?.status;
      const data = error.response?.data;
      const errorMessage =
        data?.message ||
        (status === 409
          ? "This email is already registered. Please use a different email or sign in."
          : "Registration failed. Please try again.");
      showErrorToast(errorMessage);
    }
          } else {
            this.setState({ loading: false });
            showErrorToast("Please agree with our terms and conditions.");
          }
        } else {
          this.setState({ loading: false });
          showErrorToast("Password should be at least eight characters long.");
        }
      } else {
        this.setState({ loading: false });
        showErrorToast("Please provide a valid email address.");
      }
    } else {
      this.setState({ loading: false });
      showErrorToast("Please provide your first and last name.");
    }
  }

  render() {
    const { loading, registerAs } = this.state;
    
    // Check if it's mobile/tablet view
    const isMobile = window.innerWidth <= 768;
    const isTablet = window.innerWidth <= 1024 && window.innerWidth > 768;
    
    return (
      loading ? <Preloader /> :
      <div className="pondstat-register-page" style={{
        minHeight: '100vh',
        display: 'flex',
        backgroundColor: isMobile ? '#ffffff' : '#f8f9fa',
        backgroundImage: isMobile ? 'none' : "url(/assets/img/NewPondStatDataEntryHomePage2.png)",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: '0'
      }}>
        
        {/* Left side - Background with branding (Hidden on mobile) */}
        {!isMobile && (
          <div style={{
            flex: isTablet ? '0.6' : '1',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: isTablet ? '40px' : '60px'
          }}>
            {/* Overlay for better text readability */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.3)'
            }}></div>
            
            {/* Logo and Title - Centered */}
            <div style={{ 
              position: 'relative', 
              zIndex: 2, 
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <div style={{
                fontSize: isTablet ? '3.5rem' : '4.5rem',
                fontWeight: 'bold',
                color: 'white',
                marginBottom: '20px',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
              }}>
                <span style={{ color: '#333' }}>POND</span>
                <span style={{ color: '#4ECDC4' }}>STAT</span>
              </div>
              
              <div style={{
                fontSize: isTablet ? '2rem' : '2.5rem',
                color: 'white',
                fontWeight: '300',
                marginBottom: '10px',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
              }}>
                Data Entry
              </div>
              <div style={{
                fontSize: isTablet ? '1.5rem' : '2rem',
                color: 'white',
                fontWeight: '300',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
              }}>
                and
              </div>
              <div style={{
                fontSize: isTablet ? '2rem' : '2.5rem',
                color: 'white',
                fontWeight: '300',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
              }}>
                Data Reduction
              </div>
            </div>
          </div>
        )}

        {/* Right side - Form container */}
        <div style={{
          width: isMobile ? '100%' : isTablet ? '400px' : '450px',
          backgroundColor: 'transparent',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: isMobile ? 'center' : 'center',
          padding: isMobile ? '20px' : isTablet ? '30px' : '40px',
          position: 'relative',
          minHeight: isMobile ? '100vh' : 'auto'
        }}>

          {/* Combined Title and Form Container */}
          <div style={{
            backgroundColor: isMobile ? '#ffffff' : 'rgba(255, 255, 255, 0.95)',
            borderRadius: '20px',
            padding: isMobile ? '30px' : '40px',
            boxShadow: isMobile ? 'none' : '0 8px 25px rgba(0,0,0,0.15)',
            marginBottom: isMobile ? '20px' : '25px'
          }}>
            {/* Title Section */}
            <div style={{ 
              textAlign: 'center', 
              marginBottom: '30px' 
            }}>
              <h2 style={{ 
                color: '#333', 
                marginBottom: '12px',
                fontSize: isMobile ? '24px' : '28px',
                fontWeight: '700'
              }}>
                Sign Up
              </h2>
              <div className="d-flex gap-2 justify-content-center mb-3 flex-wrap">
                <button
                  type="button"
                  className={`btn btn-sm rounded-pill px-3 ${registerAs === "organization" ? "btn-primary" : "btn-outline-secondary"}`}
                  onClick={() => this.setState({ registerAs: "organization" })}
                >
                  Pond Owner
                </button>
                <button
                  type="button"
                  className={`btn btn-sm rounded-pill px-3 ${registerAs === "scientist" ? "btn-primary" : "btn-outline-secondary"}`}
                  onClick={() => this.setState({ registerAs: "scientist" })}
                >
                  Independent Scientist
                </button>
                <button
                  type="button"
                  className={`btn btn-sm rounded-pill px-3 ${registerAs === "company" ? "btn-primary" : "btn-outline-secondary"}`}
                  onClick={() => this.setState({ registerAs: "company" })}
                >
                  Pond Management Company
                </button>
              </div>
              <p style={{ 
                color: '#666', 
                fontSize: isMobile ? '14px' : '16px',
                margin: '0',
                lineHeight: '1.5'
              }}>
                {registerAs === "scientist"
                  ? "Create one account. Pond owners will invite you by email to access their ponds."
                  : registerAs === "company"
                  ? "Free company signup. Create and pay for pond owner accounts after you log in."
                  : "Create your PondStat pond owner account"}
              </p>
            </div>
            <form onSubmit={this.handleSubmit}>
              {registerAs === "company" && (
                <>
                  <div style={{ marginBottom: '25px' }}>
                    <label style={{
                      display: 'block',
                      marginBottom: '10px',
                      color: '#333',
                      fontSize: '15px',
                      fontWeight: '600'
                    }}>
                      Company name <span style={{ color: '#dc3545' }}>*</span>
                    </label>
                    <input
                      type="text"
                      id="txtCompanyName"
                      className="form-control"
                      placeholder="Company name"
                      required
                      style={{
                        padding: isMobile ? '14px 16px' : '15px 18px',
                        border: '2px solid #e1e5e9',
                        borderRadius: '12px',
                      }}
                    />
                  </div>
                  <div style={{ marginBottom: '25px' }}>
                    <label style={{
                      display: 'block',
                      marginBottom: '10px',
                      color: '#333',
                      fontSize: '15px',
                      fontWeight: '600'
                    }}>
                      Phone <span style={{ color: '#dc3545' }}>*</span>
                    </label>
                    <input
                      type="tel"
                      id="txtCompanyPhone"
                      className="form-control"
                      placeholder="Business phone"
                      required
                      autoComplete="tel"
                      style={{
                        padding: isMobile ? '14px 16px' : '15px 18px',
                        border: '2px solid #e1e5e9',
                        borderRadius: '12px',
                      }}
                    />
                  </div>
                  <div style={{ marginBottom: '25px' }}>
                    <label style={{
                      display: 'block',
                      marginBottom: '10px',
                      color: '#333',
                      fontSize: '15px',
                      fontWeight: '600'
                    }}>
                      Street address <span style={{ color: '#dc3545' }}>*</span>
                    </label>
                    <input
                      type="text"
                      id="txtCompanyAddress"
                      className="form-control"
                      placeholder="Street address"
                      required
                      autoComplete="street-address"
                      style={{
                        padding: isMobile ? '14px 16px' : '15px 18px',
                        border: '2px solid #e1e5e9',
                        borderRadius: '12px',
                      }}
                    />
                  </div>
                  <div style={{
                    marginBottom: '25px',
                    display: 'flex',
                    gap: '15px',
                    flexDirection: isMobile ? 'column' : 'row',
                  }}>
                    <div style={{ flex: 1 }}>
                      <label style={{
                        display: 'block',
                        marginBottom: '10px',
                        color: '#333',
                        fontSize: '15px',
                        fontWeight: '600'
                      }}>
                        City <span style={{ color: '#dc3545' }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="txtCompanyCity"
                        className="form-control"
                        placeholder="City"
                        required
                        autoComplete="address-level2"
                        style={{
                          padding: isMobile ? '14px 16px' : '15px 18px',
                          border: '2px solid #e1e5e9',
                          borderRadius: '12px',
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{
                        display: 'block',
                        marginBottom: '10px',
                        color: '#333',
                        fontSize: '15px',
                        fontWeight: '600'
                      }}>
                        State / region
                      </label>
                      <input
                        type="text"
                        id="txtCompanyState"
                        className="form-control"
                        placeholder="State or region"
                        autoComplete="address-level1"
                        style={{
                          padding: isMobile ? '14px 16px' : '15px 18px',
                          border: '2px solid #e1e5e9',
                          borderRadius: '12px',
                        }}
                      />
                    </div>
                  </div>
                  <div style={{
                    marginBottom: '25px',
                    display: 'flex',
                    gap: '15px',
                    flexDirection: isMobile ? 'column' : 'row',
                  }}>
                    <div style={{ flex: 1 }}>
                      <label style={{
                        display: 'block',
                        marginBottom: '10px',
                        color: '#333',
                        fontSize: '15px',
                        fontWeight: '600'
                      }}>
                        Postal / ZIP code
                      </label>
                      <input
                        type="text"
                        id="txtCompanyPostal"
                        className="form-control"
                        placeholder="ZIP or postal code"
                        autoComplete="postal-code"
                        style={{
                          padding: isMobile ? '14px 16px' : '15px 18px',
                          border: '2px solid #e1e5e9',
                          borderRadius: '12px',
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{
                        display: 'block',
                        marginBottom: '10px',
                        color: '#333',
                        fontSize: '15px',
                        fontWeight: '600'
                      }}>
                        Country <span style={{ color: '#dc3545' }}>*</span>
                      </label>
                      <select
                        id="txtCompanyCountry"
                        className="form-control"
                        required
                        defaultValue="US"
                        style={{
                          padding: isMobile ? '14px 16px' : '15px 18px',
                          border: '2px solid #e1e5e9',
                          borderRadius: '12px',
                        }}
                      >
                        {COUNTRY_OPTIONS.map((c) => (
                          <option key={c.code} value={c.code}>
                            {c.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div style={{ marginBottom: '25px' }}>
                    <label style={{
                      display: 'block',
                      marginBottom: '10px',
                      color: '#333',
                      fontSize: '15px',
                      fontWeight: '600'
                    }}>
                      EIN <span style={{ color: '#888', fontWeight: 500 }}>(optional)</span>
                    </label>
                    <input
                      type="text"
                      id="txtCompanyEin"
                      className="form-control"
                      placeholder="Employer Identification Number"
                      autoComplete="off"
                      style={{
                        padding: isMobile ? '14px 16px' : '15px 18px',
                        border: '2px solid #e1e5e9',
                        borderRadius: '12px',
                      }}
                    />
                  </div>
                </>
              )}
              {/* Name Fields */}
              <div style={{ marginBottom: '25px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '10px',
                  color: '#333',
                  fontSize: '15px',
                  fontWeight: '600'
                }}>
                  {registerAs === "company" ? "Manager name" : "Name"} <span style={{ color: '#dc3545' }}>*</span>
                </label>
                <div style={{ display: 'flex', gap: '15px', flexDirection: isMobile ? 'column' : 'row' }}>
                  <input
                    type="text"
                    id='txtFirstName'
                    className="form-control"
                    placeholder="First name"
                    required
                    style={{
                      flex: '1',
                      padding: isMobile ? '14px 16px' : '15px 18px',
                      border: '2px solid #e1e5e9',
                      borderRadius: '12px',
                      fontSize: '16px',
                      transition: 'all 0.3s ease',
                      outline: 'none',
                      backgroundColor: '#fff'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#4ECDC4';
                      e.target.style.boxShadow = '0 0 0 3px rgba(78, 205, 196, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e1e5e9';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                  <input
                    type="text"
                    id='txtLastName'
                    className="form-control"
                    placeholder="Last name"
                    required
                    style={{
                      flex: '1',
                      padding: isMobile ? '14px 16px' : '15px 18px',
                      border: '2px solid #e1e5e9',
                      borderRadius: '12px',
                      fontSize: '16px',
                      transition: 'all 0.3s ease',
                      outline: 'none',
                      backgroundColor: '#fff'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#4ECDC4';
                      e.target.style.boxShadow = '0 0 0 3px rgba(78, 205, 196, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e1e5e9';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>
              </div>

              {/* Email Field */}
              <div style={{ marginBottom: '25px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '10px',
                  color: '#333',
                  fontSize: '15px',
                  fontWeight: '600'
                }}>
                  Email <span style={{ color: '#dc3545' }}>*</span>
                </label>
                <input
                  type="email"
                  id='txtEmailAddress'
                  className="form-control"
                  placeholder="Enter your email address"
                  required
                  style={{
                    width: '100%',
                    padding: isMobile ? '14px 16px' : '15px 18px',
                    border: '2px solid #e1e5e9',
                    borderRadius: '12px',
                    fontSize: '16px',
                    transition: 'all 0.3s ease',
                    outline: 'none',
                    backgroundColor: '#fff'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#4ECDC4';
                    e.target.style.boxShadow = '0 0 0 3px rgba(78, 205, 196, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e1e5e9';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>

              {/* Password Field */}
              <div style={{ marginBottom: '25px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '10px',
                  color: '#333',
                  fontSize: '15px',
                  fontWeight: '600'
                }}>
                  Password <span style={{ color: '#dc3545' }}>*</span>
                </label>
                <input
                  type="password"
                  id='txtPassword'
                  className="form-control"
                  placeholder="Enter your password (min 8 characters)"
                  required
                  style={{
                    width: '100%',
                    padding: isMobile ? '14px 16px' : '15px 18px',
                    border: '2px solid #e1e5e9',
                    borderRadius: '12px',
                    fontSize: '16px',
                    transition: 'all 0.3s ease',
                    outline: 'none',
                    backgroundColor: '#fff'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#4ECDC4';
                    e.target.style.boxShadow = '0 0 0 3px rgba(78, 205, 196, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e1e5e9';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>

              {/* Agreement Checkbox */}
              <div style={{ marginBottom: '25px' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="agreementCheckbox"
                    required
                    style={{
                      marginTop: '4px',
                      transform: 'scale(1.2)'
                    }}
                  />
                  <label 
                    className="form-check-label" 
                    htmlFor="agreementCheckbox"
                    style={{
                      fontSize: '14px',
                      color: '#666',
                      lineHeight: '1.5'
                    }}
                  >
                    By clicking Sign Up, you agree to our <Link 
                      to="#" 
                      style={{ color: '#4ECDC4', textDecoration: 'none' }}
                    >Terms</Link> and that you have read our <Link 
                      to="#" 
                      style={{ color: '#4ECDC4', textDecoration: 'none' }}
                    >Data Policy</Link>, including our <Link 
                      to="#" 
                      style={{ color: '#4ECDC4', textDecoration: 'none' }}
                    >Cookie Use</Link>.
                  </label>
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: isMobile ? '16px' : '18px',
                  backgroundColor: loading ? '#ccc' : '#4ECDC4',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  fontSize: '16px',
                  fontWeight: '700',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  marginBottom: '25px',
                  boxShadow: '0 4px 15px rgba(78, 205, 196, 0.3)',
                  transform: 'translateY(0)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
                onMouseOver={(e) => {
                  if (!loading) {
                    e.target.style.backgroundColor = '#45b7aa';
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(78, 205, 196, 0.4)';
                  }
                }}
                onMouseOut={(e) => {
                  if (!loading) {
                    e.target.style.backgroundColor = '#4ECDC4';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(78, 205, 196, 0.3)';
                  }
                }}
              >
                {loading ? (
                  <>
                    <div style={{
                      width: '18px',
                      height: '18px',
                      border: '2px solid #ffffff',
                      borderTop: '2px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                    Creating Account...
                  </>
                ) : (
                  <>
                    <i className="fas fa-user-plus"></i>
                    {registerAs === "scientist" ? "Sign Up as Scientist" : "Sign Up"}
                  </>
                )}
              </button>

              <div style={{ 
                textAlign: 'center', 
                marginBottom: '0',
                color: '#666',
                fontSize: '14px'
              }}>
                Already a member? <Link 
                  to="/user/login" 
                  style={{ 
                    color: '#4ECDC4', 
                    textDecoration: 'none',
                    fontWeight: '600',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#45b7aa'}
                  onMouseOut={(e) => e.target.style.color = '#4ECDC4'}
                >
                  Login here
                </Link>
              </div>
            </form>
          </div>

          {/* Copyright Footer */}
          <div style={{
            backgroundColor: isMobile ? '#ffffff' : 'rgba(255, 255, 255, 0.95)',
            borderRadius: '20px',
            padding: '18px',
            boxShadow: isMobile ? 'none' : '0 8px 25px rgba(0,0,0,0.15)',
            textAlign: 'center',
            marginTop: '20px'
          }}>
            <div style={{
              color: '#999',
              fontSize: '12px',
              fontWeight: '500'
            }}>
              &copy; PONDSTAT. All Rights Reserved
            </div>
          </div>

        </div>

        {/* CSS Animation for loading spinner */}
        <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }
}

export default withRouter(Register);